package org.catharsis.spendtel.feature.presentation

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import org.catharsis.spendtel.feature.presentation.web.WebExpenseReportScreen

@Composable
actual fun ExpenseReportScreen(
    navHostController: NavHostController,
    reportId: String,
) {
    WebExpenseReportScreen(
        navHostController = navHostController,
        reportId = reportId,
    )
}
